// https://github.com/ionic-team/ionic-plugin-deeplinks


const callbacks = [];


// Register a callback.  It will be called whenever the app is opened from the
// custom URL.  It may be called multiple times during the life of the
// application.
//
// Callback called with a URL object.
export function onDeepLink(callback) {
  if (!callbacks.includes(callback))
    callbacks.push(callback);
}


function listenForDeeplinks() {
  const { IonicDeeplink } = window;

  if (!IonicDeeplink)
    return;

  IonicDeeplink.onDeepLink(function({ url }) {
    handleDeepLink(url);
  });
}


function handleDeepLink(url) {
  const urlWithoutHash = url.replace('/#/', '/');
  const urlObject      = new URL(urlWithoutHash);

  for (const callback of callbacks)
    callback(urlObject);
}



// For testing purposes.
window._handleDeepLink = handleDeepLink;


// By this time deviceready event already fired
// (see phonegap/index.html).
listenForDeeplinks();
